import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './index.component.html',
    styleUrls: ['./index.component.css'],
    standalone: false
})
export class IndexComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
